export const pathIds = {
  '/home': 'home',
  '/calendar': 'calendar',
  '/sports': 'sports',
  '/settings': 'settings',
  '/settings/subscriptions': 'subscriptions',
  '/settings/account': 'account',
  '/settings/imprint': 'imprint',
  '/settings/data-privacy': 'privacy',
  '/settings/analytics-cookie': 'legal',
  '/settings/developer': 'developer',
  '/selected': 'selected',
  '/settings/region': 'region',
  '/favorites': 'favorites',
  '/predict': 'predict',
  '/feature-screen': 'feature-screen',
}
